<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
				<FormItem label="姓名" prop="name" class="sj">
					<Input v-model="formValidate.name" placeholder="请输入姓名"></Input>
				</FormItem>
				<FormItem label="联系方式" prop="phone" class="sj">
					<Input v-model="formValidate.phone" placeholder="请输入联系方式"></Input>
				</FormItem>
				<FormItem label="区划信息"  class="" prop="regionId">
					<Row>
						<Col span="12">
							<FormItem  class="">
								<Region @setRegion="setRegion" t="plat"></Region>
							</FormItem>
						</Col>
					</Row>
				</FormItem>
				<FormItem label="家庭住址" prop="address" class="sj">
					<Input v-model="formValidate.address" placeholder="请输入家庭住址"></Input>
				</FormItem>
				<FormItem label="登录名" class="sj">
					<Input v-model="formValidate.phone" placeholder="请输入登录名" disabled="disabled"></Input>
				</FormItem>
				<FormItem label="密码" prop="password" class="sj">
					<Input v-model="formValidate.password" placeholder="请输入密码"></Input>
				</FormItem>
				<FormItem label="状态" prop="state" class="sj">
					<Select v-model="formValidate.state" placeholder="请选择状态">
						<Option value="true">启用</Option>
						<Option value="false">禁用</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	import Region from '@/components/comm/region1.vue'
	export default {
		data() {
			return {
				formValidate: {
					name: '',
					phone: '',
					address: '',
					loginName: '',
					password: '',
					state: 'true',
					jmType:'PLATFORM',
					regionId:''
				},
				ruleValidate: {
					regionId: [{
						required: true,
						message: '区域不能为空！！！',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '姓名不能为空！！！',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '联系方式不能为空！！！',
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: '家庭住址不能为空！！！',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '密码不能为空！！！',
						trigger: 'blur'
					}],
					state: [{
						required: true,
						message: '状态不能为空！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			setRegion(regionId){
				this.formValidate.regionId=regionId
			},
			handleSubmit(name) {
				let _this=this
				this.$refs[name].validate((valid) => {
					if (valid) {
						this.formValidate.username=this.formValidate.phone
						
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/plat/jm/emp/add',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('新增成功!');
								_this.$refs[name].resetFields();
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
						

					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		},
		components:{
			Region
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/plat/add.vue